import { createApp } from "vue";
import App from "./App.vue";

import { createPinia } from "pinia";
const pinia = createPinia();
import Antd from "ant-design-vue";
import elementPlus from "element-plus";
import "element-plus/dist/index.css";
import "ant-design-vue/dist/antd.css";
import "@/styles/index.css";
import '@/assets/font/font.css'
import router from "./router/index";
import store from './store'
import animated from 'animate.css'

createApp(App).use(pinia).use(router).use(Antd).use(store).use(elementPlus).use(animated).mount("#app");
